import React, { useEffect, useContext } from "react";
import "./App.css";
import Navbar from "./components/Header";

import "react-toastify/dist/ReactToastify.css";
import Sales from "./components/Sales";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Route, Switch, Link } from "react-router-dom";
import Modal from "./modal";
import LogoutModal from "./logoutModal";
import { useSelector, useDispatch } from "react-redux";
import { UserDataAction, iodData, Provider } from "./redux/actions/index";
import { toast } from "react-toastify";
import Web3 from "web3";
import { serverURL } from "./server";
import axios from "axios";
import { BscConnector } from "@binance-chain/bsc-connector";
import JoinSale from "./components/join-sale/JoinSale";
import CloseSale from "./components/close-sale/CloseSale";
import UpComing from "./components/upcoming-sale/UpcomingSale";
import Buy from "./components/join-sale/Buy";
import Home from "./components/Home";
import Close from "./components/close-sale/CloseClaim";
export default function App() {
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [loading, setloading] = React.useState(true);
  const dispatch = useDispatch();
  const { stakeContract, hodlTokenContract, data, busdContract, hodlContract } =
    useSelector((state) => state.UserReducer);

  const ConnectToWallet = () => {
    const web3 = new Web3(Web3.givenProvider || "http://localhost8545");
    Ethereum();
    async function Ethereum() {
      window.ethereum && window.ethereum.enable();
      if (typeof window.ethereum !== "undefined") {
        let connectAccount = setInterval(async () => {
          const account = await window.ethereum.request({
            method: "eth_requestAccounts",
          });
          let balance;
          let networkid;
          try {
            balance =
              (await web3.eth.getBalance(account[0])) / 1000000000000000000;
            networkid = await web3.eth.net.getId();
          } catch (error) {
            console.log(error);
          }

          if (account) {
            localStorage.setItem("wallet", "meta");
            const balance =
              (await web3.eth.getBalance(account[0])) / 1000000000000000000;

            await dispatch(Provider("mm"));
            dispatch(UserDataAction(account[0], balance, networkid));
          }
          clearInterval(connectAccount);
        }, 500);
      } else {
        toast.error("Error! Please install metamask");
      }
    }
  };
  const bsc = new BscConnector({
    supportedChainIds: [56, 97], // later on 1 ethereum mainnet and 3 ethereum ropsten will be supported
  });
  const BincanceWallet = async () => {
    try {
      if (window && typeof window.BinanceChain !== "undefined") {
        main();
      }
    } catch (e) {}
  };
  const main = async () => {
    const web3 = new Web3(window.BinanceChain || "http://localhost8545");
    await bsc.getAccount().then(async (val) => {
      let balance;
      let networkid;
      try {
        balance = (await web3.eth.getBalance(val)) / 1000000000000000000;
        networkid = await web3.eth.net.getId();
        console.log(networkid);
      } catch (error) {
        console.log(error);
      }
      if (val) {
        await dispatch(Provider("bsc"));
        const balance = (await web3.eth.getBalance(val)) / 1000000000000000000;
        dispatch(UserDataAction(val, balance, networkid));
        localStorage.setItem("wallet", "bnb");
      }
    });
  };

  useEffect(() => {
    func();
    async function func() {
      try {
        var data = await axios.get(serverURL + "IODData");
        console.log(data.data.success);
        dispatch(iodData(data.data.iod));
        dispatch(UserDataAction());
        const storage = localStorage.getItem("wallet");
        if (storage == "meta") {
          ConnectToWallet();
        } else if (storage == "bnb") {
          BincanceWallet();
        }
      } catch (error) {}
    }
  }, [loading]);
  useEffect(() => {
    setTimeout(() => {
      setloading(false);
    }, 3000);
  });

  if (loading) {
    return (
      <div class="out-loading">
        <div class="wrapper">
          <span class="circle circle-1"></span>
          <span class="circle circle-2"></span>
          <span class="circle circle-3"></span>
          <span class="circle circle-4"></span>
          <span class="circle circle-5"></span>
          <span class="circle circle-6"></span>
          <span class="circle circle-7"></span>
          <span class="circle circle-8"></span>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <Modal
          open={open}
          setOpen={setOpen}
          connectWalletFunction={ConnectToWallet}
          BincanceWallet={BincanceWallet}
        />
        <LogoutModal open={open1} setOpen1={setOpen1} />
        <BrowserRouter>
          <div id="main">
            <Navbar setOpen={setOpen} setOpen1={setOpen1} />
            <ToastContainer />
            <Route exact path="/" setloading={setloading} component={Home} />
            <Route
              exact
              path="/create-sale"
              setloading={setloading}
              component={Sales}
            />
            <Route
              exact
              path="/join-sale"
              setloading={setloading}
              component={JoinSale}
            />
            <Route
              exact
              path="/join-sales/:id"
              setloading={setloading}
              component={Buy}
            />
            <Route
              exact
              path="/close-sales/:id"
              setloading={setloading}
              component={Close}
            />
            <Route
              exact
              path="/close-sale"
              setloading={setloading}
              component={CloseSale}
            />
            <Route
              exact
              path="/upcoming-sale"
              setloading={setloading}
              component={UpComing}
            />
            {/* <Route
              exact
              path="/staking"
              setloading={setloading}
              component={Staking}
            />
            <Route exact path="/projects" component={Projects} />
            <Route exact path="/openprojects/:id" component={PoolBuy} /> */}
          </div>
        </BrowserRouter>
      </>
    );
  }
}
